import types from './types';
import {CALL_API} from 'redux-api-middleware';

const apiUrl = '/api/settings';

export function submitSettings(values) {
    return {
        [CALL_API]: {
            endpoint: apiUrl,
            method: 'PUT',
            body: values,
            types: types.SUBMIT_SETTINGS.all
        }
    };
}
export function fetchSettings() {
    return {
        [CALL_API]: {
            endpoint: apiUrl,
            method: 'GET',
            types: types.LOAD_SETTINGS.all
        }
    };
}



// WEBPACK FOOTER //
// ./src/js/actions/settings.js